import { toast } from 'react-toastify';

export function validateAttachmentName(acceptedFiles) {
  if(!acceptedFiles[0]) return false;
  //min length after escape name, accept only alphanumeric
  if(acceptedFiles[0].name.replace(/[^a-zA-Z0-9]+/g, '').length < 4) {
    toast("File has bad name, it should contains of only alphanumeric and name length must be more that 4.", { type: "error" });
    return false;
  }
  return true;
}
